<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}
.el-message__icon{
  font-size: 0.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue